import {Component, ElementRef, OnInit, Renderer2, ViewChild} from '@angular/core';
import {Subscription} from 'rxjs';
import {InformationModel, WidgetInfoModel, WidgetModel} from '../../core/models/widget.model';
import {SidemenuDragAndDropService} from 'lps-navigation';
import {SideMenuItemModel} from '../../core/models/sidemenu.model';
import {HomeManagerService} from '../service/home-manager.service';
import {HomeService} from '../service/home.service';

export interface Ranges {
  field: string;
  from?: string;
  to?: string;
}

@Component({
  selector: 'app-home-manager',
  templateUrl: './home-manager.component.html',
  styleUrls: ['./home-manager.component.scss']
})
export class HomeManagerComponent implements OnInit {
  public width;

  @ViewChild('dragContainer', { read: ElementRef, static: true })
  dragContainer: ElementRef;

  @ViewChild('dragElement', { read: ElementRef, static: true })
  dragEelement: ElementRef;

  @ViewChild('widgetsDropdownContainer', { read: ElementRef, static: true })
  widgetsDropdownContainer: ElementRef;

  get hasFinishedLoading() { return this.homeManagerService.getDashDataFinished; }
  get dropMask(): boolean { return this.dnd.isDragging; }
  get draggedItem() { return this.dnd.draggedItem; }
  get draggedItemInfo() { return this.dnd.draggedItemInfo; }
  get dragIdx() { return this.dnd.draggedItemIndex; }
  get draggedType() { return this.dnd.draggedType; }
  get draggableSidemenuItems() { return this.homeManagerService.sideMenuDraggables; }

  public smWidgetsSubscription: Subscription;
  public widgetInfoSubscription: Subscription;
  public smallWidgets: WidgetModel[];
  public smallWidgetsInfo: InformationModel[][] = [[], [], [], []];

  public dropAreaId: string;
  public dragScrollStarted: boolean;
  public dragScrolling: boolean;
  public isDown: boolean;
  public startX: number;
  public scrollLeft: number;
  public showWidgetsBackdrop: boolean;
  public showWidgetsDropdown: boolean[] = [ false, false, false, false ];

  constructor(
      private dnd: SidemenuDragAndDropService,
      private homeSvc: HomeService,
      private homeManagerService: HomeManagerService,
      private renderer: Renderer2,
  ) { }

  ngOnInit() {
    if (!this.smallWidgets) { this.smallWidgets = []; }
    this.homeManagerService.getManagerDashData();
    this.smWidgetsSubscription = this.homeManagerService.getSmWidgets().subscribe(widgets => this.smallWidgets = widgets);
    this.widgetInfoSubscription = this.homeManagerService.getwidgetInfo().subscribe(widgetsInfo => this.updateInfo(widgetsInfo));
    this.homeManagerService.getDraggableSidemenuItems();
  }

  updateInfo(widgetInfo: WidgetInfoModel): void {
    for (let i = 0; i < this.smallWidgets.length; i++) {
      if (widgetInfo.id === this.smallWidgets[i].id) {
        this.smallWidgetsInfo[i] = widgetInfo.info;
      }
    }
  }

  initDragScroll(event: MouseEvent) {
    event.preventDefault();
    if (this.dragScrollStarted || !this.hasFinishedLoading) {
      return;
    }
    this.dragScrollStarted = true;
    this.dragScroll();
  }

  dragScroll() {
      const slider = document.querySelector('.dash-container-sm');
      if (slider) {
        slider.addEventListener('mousedown', (e: MouseEvent) => {
          this.isDown = true;
          this.startX = e.pageX - slider.clientLeft;
          this.scrollLeft = slider.scrollLeft;
          setTimeout(() => { this.dragScrolling = true; }, 250);
        });
        slider.addEventListener('mouseleave', () => {
          this.isDown = false;
        });
        slider.addEventListener('mouseup', (e: MouseEvent) => {
          this.isDown = false;
          setTimeout(() => { this.dragScrolling = false; }, 100);
        });
        slider.addEventListener('mousemove', (e: MouseEvent) => {
          if (!this.isDown) {
            this.dragScrolling = false;
            return;
          }
          e.preventDefault();
          const x = e.pageX - slider.clientLeft;
          const walk = (x - this.startX);
          slider.scrollLeft = this.scrollLeft - walk;
        });
      }
    }

  checkScroll(event: PointerEvent) {
      if (event.buttons !== 1 || !this.dnd.draggedItem) { return false; }
      const widgetContainerSm = document.getElementById('widget-container-sm');
      const widgetContainerSmY = widgetContainerSm.getBoundingClientRect().top;
      const widgetContainerSmYFinal = widgetContainerSmY + 189;
      const windowWidth = window.innerWidth;
      if (this.dnd.isDragging && event.clientY > widgetContainerSmY && event.clientY < widgetContainerSmYFinal) {
        if (windowWidth - event.clientX < 50) {
          widgetContainerSm.scrollBy({ top: 0, left: 330, behavior: 'smooth' });
        } else if (event.clientX < 50) {
          widgetContainerSm.scrollBy({ top: 0, left: -330, behavior: 'smooth' });
        }
      }
    }

  startWidgetDrag(event: PointerEvent, i: number) {
      event.preventDefault();
      if (event.buttons !== 1) { return false; }
      const yOffset = window.pageYOffset;
      const draggedItem = this.smallWidgets[i];
      const draggedItemInfo = this.smallWidgetsInfo[i];
      this.dnd.setDraggedItem(draggedItem, 'widget', i, draggedItemInfo);
      this.renderer.setStyle(this.dragContainer.nativeElement, 'display', 'block');
      this.renderer.setStyle(this.dragContainer.nativeElement, 'cursor', 'grabbing');
      this.renderer.setStyle(this.dragEelement.nativeElement, 'left', `${event.clientX - 250}px`);
      this.renderer.setStyle(this.dragEelement.nativeElement, 'top', `${event.clientY - 20 + yOffset}px`);
    }

  moveDraggedWidget(event: PointerEvent) {
      this.checkScroll(event);
      const yOffset = window.pageYOffset;
      this.renderer.setStyle(this.dragEelement.nativeElement, 'left', `${event.clientX - 250}px`);
      this.renderer.setStyle(this.dragEelement.nativeElement, 'top', `${event.clientY - 20 + yOffset}px`);
    }

  finishWidgetDrag(event: PointerEvent) {
      event.preventDefault();
      this.renderer.setStyle(this.dragContainer.nativeElement, 'display', 'none');
      this.dropAreaId = document.elementFromPoint(event.clientX, event.clientY).id;
      this.widgetDrop();
    }

  widgetDrop() {
      let dropIdx = -1;
      if (this.dropAreaId.includes('dash-widget-sm')) {
        dropIdx = parseInt(this.dropAreaId.substr(15), 10);
        if (this.dragIdx !== dropIdx) {
          this.smallWidgetsInfo[dropIdx] = this.smallWidgetsInfo.splice(this.dragIdx, 1, this.smallWidgetsInfo[dropIdx])[0];
          this.smallWidgets[dropIdx] = this.smallWidgets.splice(this.dragIdx, 1, this.smallWidgets[dropIdx])[0];
          this.homeSvc.updateDashData(this.smallWidgets);
        }
      }
      this.dnd.clearDraggedItem();
    }

  addWidgetsDropdown(index: number) {
      this.showWidgetsDropdown[index] = true;
      this.showWidgetsBackdrop = true;
    }

  confirmAddWidgetDropdown(dropdownItem: SideMenuItemModel, index: number) {
      this.smallWidgets[index] = {
        id: dropdownItem.id,
        type: dropdownItem.label,
        title: dropdownItem.card_title,
        update_timer: dropdownItem.card_update_timer,
        action: dropdownItem.action
      };
      this.homeSvc.updateDashData(this.smallWidgets);
      this.showWidgetsBackdrop = false;
      this.showWidgetsDropdown = [ false, false, false, false ];
    }

  cancelAddWidgetDropdown() {
      this.showWidgetsBackdrop = false;
      this.showWidgetsDropdown = [ false, false, false, false ];
    }

  removeWidget(index: number) {
      this.smallWidgets.splice(index, 1, {});
      this.smallWidgetsInfo.splice(index, 1, [{}]);
      this.homeSvc.updateDashData(this.smallWidgets);
    }

}
